import React, { useState, useEffect, useContext } from "react";

import kebabCase from "lodash.kebabcase";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import Link from "next/link";
import { useParams } from "../../shared/hooks/useNavigation";
import { useRouter } from "../../shared/hooks/useNavigation";
import styled from "styled-components";

import ComponentContext from "../../contexts/ComponentContext";
import { fetchAPI } from "../../lib/api";
import RedirectButton from "../../shared/components/RedirectButton/RedirectButton";
import Markdown from "../../shared/styles/Markdown";

const dateOptions = {
  day: "numeric",
  month: "long",
  year: "numeric",
};

const StyledImageWrapper = styled.div`
  position: relative;
  height: 170px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

const StyledCard = styled.div`
  cursor: pointer;
`;

function LatestBlogs() {
  const { postsToShow, title, readAllText } = useContext(ComponentContext);
  const [latestPosts, setLatestPosts] = useState([]);
  const router = useRouter();
  const searchParams = useParams();

  const postId = searchParams?.postId;

  useEffect(() => {
    let currentPostId = null;
    if (router.route === "/blog/[...postId]") {
      const [currentId] = postId;
      currentPostId = currentId;
    }

    fetchAPI("/posts", {
      pagination: { page: 1, pageSize: postsToShow },
      populate: "*",
      sort: "createdAt:desc",
    }).then((response) => {
      const posts = response.data.filter(
        (post) => post.id !== Number(currentPostId)
      );
      setLatestPosts(posts);
    });
  }, [router]);

  return (
    <>
      <Markdown className="mb-4">{title}</Markdown>
      <div className="row latest-blogs">
        {latestPosts.map((post) => {
          const coverData = post.cover;
          const date = new Date(post.publishedAt).toLocaleString(
            router.locale,
            dateOptions
          );

          return (
            <div
              key={post.id}
              className="col-md-4 latest-blog position-relative"
            >
              <Link
                href={`/blog/${post.id}/${kebabCase(post.title)}`}
                legacyBehavior
              >
                <StyledCard>
                  <StyledImageWrapper className="mb-3">
                    {coverData && (
                      <Image
                        alt={post.title ?? "Card image"}
                        height={coverData.height}
                        layout="fill"
                        objectFit="cover"
                        src={coverData.url}
                        width={coverData.width}
                      />
                    )}
                  </StyledImageWrapper>
                  <h2>{post.title}</h2>
                  <p className="text-muted fs-6">{date}</p>
                  <div>
                    <p>{post.description}</p>
                  </div>
                  <span className="float-end ml-1 text-decoration-underline">
                    Read more
                  </span>
                </StyledCard>
              </Link>
            </div>
          );
        })}
      </div>
      <div className="d-flex justify-content-center">
        <RedirectButton customUrl="/blog" text={readAllText} />
      </div>
    </>
  );
}

export default observer(LatestBlogs);
